import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

// import addCookieWithConsent from '../../utilities/addCookieWithConsent';
import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {
  // tryToGetMemberships  
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Edit organization keys
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestEditOrganizationKeys = packet => {
  return {
    type: 'REQUEST_EDIT_ORGANIZATION_KEYS',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveEditOrganizationKeysSuccess = data => ({
  type: 'RECEIVE_EDIT_ORGANIZATION_KEYS_SUCCESS',
  data
})

export const receiveEditOrganizationKeysFail = data => ({
  type: 'RECEIVE_EDIT_ORGANIZATION_KEYS_FAIL',
  data
})

export const tryToEditOrganizationKeys = packet => (dispatch, getState) => {

  dispatch(requestEditOrganizationKeys(packet));

  let headers = {
    "Content-Type": "application/json"
  }

  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }

  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/organizations/keys/' + packet.id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveEditOrganizationKeysSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveEditOrganizationKeysFail({errors:e, lastSubmit: packet}));
    })
}
